<template>
    <div class="edit-mumb-card container">

        <div class="search">
            <input class="search__input" type="text" v-model="searchTerm">
            <i class="material-icons white-text search__icon">search</i>
        </div>

        <div class="edit-card">
            <div class="card" v-for="card in filteredNames " :key="card.id" :class="{ 'editing': card.editing }">
                <div class="card-content">
                    <div class="overview-wrapper" v-if="!card.editing">
                        <p class="card-title">{{ card.name }}</p>
                        <!-- btn delete -->
                        <div class="btn-floating delete" @click="deleteMumblCard(card.id)">
                            <i class="material-icons">delete</i>
                        </div>
                        <!-- btn edit -->
                        <div class="btn-floating edit" @click="editMumblCard(card.id)">
                            <i class="material-icons">edit</i>
                        </div>
                    </div>

                    <form class="editing-wrapper" @submit.prevent="updateMumblCard(card.id)" v-if="card.editing">
                        <div class="field">
                            <label class="" for="name">
                                Name
                            </label>
                            <input type="text" name="name" v-model='card.name'>
                        </div>

                        <div class="field">
                            <label for="origin">
                                Origin
                            </label>
                            <input type="text" name="origin" v-model='card.origin'>
                        </div>

                        <!--<div class="field">
                            <label for="meaning">
                                Meaning
                            </label>
                            <textarea class="materialize-textarea" name="meaning" v-model='card.meaning'></textarea>
                        </div>-->

                        <div class="radio-wrapper">
                            <div class="radio">
                                <label for="female">
                                    <input class="input-radio" id="female" name="gender" type="radio" value="female" v-if="card.gender === 'female'" checked />
                                    <input class="input-radio" id="female" name="gender" type="radio" value="female" v-else />
                                    <span>Female</span>
                                </label>
                            </div>
                            <div class="radio">
                                <label for="male">
                                    <input class="input-radio" id="male" name="gender" type="radio" value="male" v-if="card.gender === 'male'" checked />
                                    <input class="input-radio" id="male" name="gender" type="radio" value="male" v-else />
                                    <span>Male</span>
                                </label>
                            </div>
                            <div class="radio">
                                <label for="unisex">
                                    <input class="input-radio" id="unisex" name="gender" type="radio" value="unisex" v-if="card.gender === 'unisex'" checked />
                                    <input class="input-radio" id="unisex" name="gender" type="radio" value="unisex" v-else />
                                    <span>Unisex</span>
                                </label>
                            </div>
                        </div>
                        <button class="btn btn-small btn-submit">Save</button>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'

export default {
    name: 'EditMumblCard',
    props: ['editActive'],
    // local data
    data () {
        return {
            mumblCards: [],
            searchTerm: ''
        }
    },
    computed: {
        sortAbcMumblCards() {
            function compare(a, b) {
                if (a.name < b.name)
                return -1;
                if (a.name > b.name)
                return 1;
                return 0;
            }

            return this.mumblCards.sort(compare);
        },
        filteredNames() {
            return this.sortAbcMumblCards.filter(card => {
                return card.name.match(this.searchTerm)
            })
        }
    },
    // local functions
    methods: {
        deleteMumblCard(id) {
            // delete selected mumblCard (doc.id) from firestore
            db.collection('mumblCards').doc(id).delete()
            .then(() => {
                // delete selected mumblCard from local data
                this.mumblCards = this.mumblCards.filter(card => {
                    // return true for all cards which not macthes and save them in local data mumblCards
                    return card.id != id
                })
                // feedback via toast
                M.toast({
                    html: 'Name deleted',
                    displayLength: 3000,
                    classes: 'toast error'
                })
            })
        },
        editMumblCard(id) {
            // check which card is clicked and add parameter editing to true
            this.mumblCards.forEach(card => {
                if (card.id === id) {
                    card.editing = true
                } else {
                    card.editing = false
                }
            })
        },
        updateMumblCard(id) {
            this.mumblCards.forEach(card => {
                if (card.id === id) {
                    // select radio buttons
                    let radio = document.querySelectorAll('.input-radio');
                    // find checked radio button and store value to local data gender
                    for(var i = 0; i < radio.length; i++) {
                        if(radio[i].checked) {
                            card.gender = radio[i].value;
                        }
                    }
                    db.collection('mumblCards').doc(card.id).update({
                        name: card.name,
                        origin: card.origin,
                        meaning: card.meaning,
                        gender: card.gender
                    })
                    .then(() => {
                        card.editing = false
                         M.toast({
                             html: 'Changes for ' + "'" + card.name + "'" + ' Saved',
                             displayLength: 3000,
                             classes: 'toast success'
                         })
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
            })
        }
    },
    // lifecycle-hook (fires before components are rendered)
    created(){
        // fetch data from firestore
        db.collection('mumblCards').get()
        // when fetch data has completed
        .then(snapshot => {
            snapshot.forEach(doc => {
                // save each mumblCard data from Firestore in card
                let card = doc.data()
                // save auto generated doc ID from firestore to local card data
                card.id = doc.id
                // get empty mumblCards array from local data and push real data from firestore in it
                this.mumblCards.push(card)
            })
        })
    }
}
</script>


<style lang="scss">

    .search {
        position: relative;
        width: 400px;
        margin-bottom: 40px;

        &__input {
            color: #fff;
        }

        &__icon {
            position: absolute;
            top: 20px;
            right: -30px;
        }
    }

    .edit-card {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: 30px;

        .card {
            position: relative;
            margin: 0;

            &.editing {
                // grid-row: span 3;
            }
        }

        .card-content {
            padding-top: 1.6em;
            padding-bottom: 1.6em;
        }
        
        .card-title {
            text-align: center;
        }

        .btn-floating {
            position: absolute;
            top: 50%;

            &.edit {
                right: 0;
                transform: translate(30%, -50%);
            }
            &.delete {
                left: 0;
                transform: translate(-30%, -50%);
            }
        }

        .btn-submit {
            margin-top: 1.4rem;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/backend/EditMumblCard.vue